import axiosInstance from '../core/axiosconfig';

export const getProductionInsight = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/production/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching production insight:', error);
    throw error;
  }
};

export const getProductionHighlights = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/production_highlights/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching production highlights:', error);
    throw error;
  }
};

export const getIdleReasonInsight = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/idle_reason/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching idle reason insight:', error);
    throw error;
  }
};

export const getIdleReasonHighlights = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/idle_reason_highlights/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching idle reason highlights:', error);
    throw error;
  }
};

export const getAlarmInsight = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/alarm/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching alarm insight:', error);
    throw error;
  }
};

export const getBeforeAfterInsight = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/before_after_yantra/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching before/after insight:', error);
    throw error;
  }
};

export const getRoiInsight = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/roi/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching ROI insight:', error);
    throw error;
  }
};

export const getRoiCumulativeInsight = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/roi_cumulative/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching ROI cumulative insight:', error);
    throw error;
  }
};

export const getReportPdf = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight/report_pdf/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching report PDF:', error);
    throw error;
  }
};

export const getOverview1InsightCopyReportPdf = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight1/report_pdf_overview1/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    return response.data;
  } catch (error) {
    console.error('Error fetching Overview1 + Insight Copy report PDF:', error);
    throw error;
  }
};

// Overview1 / Insight Copy tabs are being iterated on against the insight1 backend copy
// (Insight1Service/Insight1Controller) — same logic as insight/*, kept separate so this
// work doesn't touch the shared insight endpoints other tabs depend on.

export const getProductionInsight1 = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight1/production/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching production insight (insight1):', error);
    throw error;
  }
};

export const getRunTimePartsInsight1 = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight1/run_time_parts/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching run time/parts insight (insight1):', error);
    throw error;
  }
};

export const getTargetPartsInsight1 = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight1/target_parts/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching target parts insight (insight1):', error);
    throw error;
  }
};

export const getRoiInsight1 = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight1/roi/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching ROI insight (insight1):', error);
    throw error;
  }
};

export const getRoiCumulativeInsight1 = async (machines, shift, startDate, endDate) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}insight1/roi_cumulative/${machineParam}/${shift}/${startDate}/${endDate}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching ROI cumulative insight (insight1):', error);
    throw error;
  }
};

export const getComponentCycleCountReport = async (machines, shift, startDate, endDate, page = 0, limit = 10) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const url = `${window._env_.SERVER_URL2}job/component_cycle_count_report/${machineParam}/${shift}/${startDate}/${endDate}/${page + 1}/${limit}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component cycle count report:', error);
    throw error;
  }
};

export const getComponentCycleCountDetail = async (machine, shift, startDate, endDate, componentName, cycleTime) => {
  try {
    const url = `${window._env_.SERVER_URL2}job/component_cycle_count_detail/${machine}/${shift}/${startDate}/${endDate}?component_name=${encodeURIComponent(componentName)}&cycle_time=${encodeURIComponent(cycleTime)}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component cycle count detail:', error);
    throw error;
  }
};

export const getComponentTotalReport = async (machines, shift, fromTime, toTime, page = 0, limit = 10) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const shiftParam = encodeURIComponent(shift);
    const url = `${window._env_.SERVER_URL2}HourReport/component-total-report?machine=${machineParam}&shift_no=${shiftParam}&from_time=${fromTime}&to_time=${toTime}&page=${page + 1}&limit=${limit}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component total report:', error);
    throw error;
  }
};

export const getComponentTotalSummary = async (machines, shift, fromTime, toTime) => {
  try {
    const machineParam = encodeURIComponent((machines || []).join(','));
    const shiftParam = encodeURIComponent(shift);
    const url = `${window._env_.SERVER_URL2}HourReport/component-total-summary?machine=${machineParam}&shift_no=${shiftParam}&from_time=${fromTime}&to_time=${toTime}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching component total summary:', error);
    throw error;
  }
};
